<Modal
    {id}
    bodyText={body}
    titleText={heading}
    on:close={confirm}
    bind:enabled
    clickOutsideCloses={true}
    confirmText={translations.CONFIRM}
    showCancel={false}
    confirmButtonType="primary"
>
    <div slot="body">
        <slot></slot>
    </div>
</Modal>

<script>
    import { createEventDispatcher } from 'svelte';

    import Modal from '../../Modal/v2/Modal.svelte';

    const dispatch = createEventDispatcher();

    const defaultI18n = {
        CONFIRM: 'Confirm'
    };

    /** @type {string} Defaults to a random string */
    export let id = Math.random().toString(36).substr(2, 16);

    /**
     * The translation property.
     * @type {Object}
     */
     export let i18n = {};
    /**
     * The title of the modal, displayed as a heading tag.
     * @type {string}
     */
    export let heading = '';
    /**
     * The content of the modal, i.e. message.
     * @type {string}
     */
    export let body = '';

    export let enabled = true;

    $: translations = { ...defaultI18n, ...i18n };

    function confirm(event) {
        dispatch('close', event.detail);
    }
</script>
